import { useEffect, useState } from 'react';
import { useSearchParams, Link, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import Meta from "../../components/Meta";
import Loading from "../../components/Loading";

import Data from "../../../repository";

import styles from '../../../styles/Entry.module.scss';

const verifyEmailSchema = yup.object({
	pin: yup.string()
		.required('PIN is required')
		.matches(/^\d+$/, 'PIN must contain only numbers')
		.min(4, 'PIN must be at least 4 digits')
		.max(6, 'PIN must be at most 6 digits')
});

function VerifyEmailAddress() {
	const location = useLocation();
	const [searchParams, setSearchParams] = useSearchParams();

	const [loading, setLoading] = useState(false);
	const [serverError, setServerError] = useState(null);
	const [resent, setResent] = useState(false);

	const {
		register,
		handleSubmit,
		formState: { errors },
		setValue
	} = useForm({
		resolver: yupResolver(verifyEmailSchema),
		defaultValues: {
			pin: ''
		}
	});

	useEffect(() => {
		let pin = searchParams.get("pin")?.substr(0, 6);
		if (isNaN(pin)) pin = "";
		if (pin) setValue('pin', pin);
	}, [searchParams, setValue]);

	const onSubmit = async (data) => {
		setLoading(true);
		setServerError(null);

		try {
			await Data.verifyEmailAddress(data.pin);
			window.location.href = "/";
		} catch (error) {
			setServerError(error.response?.data?.message || 'Invalid PIN. Please try again.');
		} finally {
			setLoading(false);
		}
	}

	const requestVerifyEmail = async () => {
		await Data.resendEmailVerification();
		setResent(true);
	}

	return (
		<>
			<Meta title="Verify Email Address" />

			<div>
				{serverError &&
					<div className={styles.error}>
						<p>{serverError}</p>
					</div>
				}

				<h1>Verify Email Address</h1>
				<p>We've sent you an email including a unique pin code to verify your email address.</p>

				<form onSubmit={handleSubmit(onSubmit)}>
					<div>
						<input
							type="text"
							inputMode="numeric"
							maxLength={6}
							disabled={loading}
							placeholder="PIN"
							{...register('pin')}
							className={errors.pin ? 'input-error' : ''}
						/>
						{errors.pin && <p className={styles.fieldError}>{errors.pin.message}</p>}
					</div>
					<button className="btn btnPrimary" disabled={loading}>
						{loading ?
							<Loading button={true} />
							:
							`Verify Email`
						}
					</button>
				</form>

				<div className={styles.alternatives}>
					{resent ?
						<p>We've resent your verification email, remember to check your spam folder if you haven't received it.</p>
						:
						<p onClick={requestVerifyEmail}>Didn't receive the email?</p>
					}
					<Link to="/log-out">Logout</Link>
				</div>
			</div>
		</>
	);
}

export default VerifyEmailAddress;
